// src/screens/FollowUp.tsx
// PAGE DISABLED - All deals now go directly to Deal Status

export default function FollowUp() {
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#6b7280' }}>
        Follow Up Page Disabled
      </h2>
      <p style={{ color: '#9ca3af', marginTop: 16, fontSize: 14 }}>
        This page has been disabled. All deals now go directly to the Deal Status page.
      </p>
    </div>
  );
}
